import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import {HomePage} from './Pages/HomePage.js';
import {ArtGallery} from './Pages/ArtGallery.js';
import { MyWorkPage } from './Pages/MyWorkPage.js';
import { BlogPage } from './Pages/BlogPage.js';
import { AboutMePage } from './Pages/AboutMePage.js';

import { NavbarTop } from './Components/NavbarTop/NavbarTop.js';
import './App.css';


function App() {

    return (
      <>
        <div className="App">
          <BrowserRouter>
            <NavbarTop/>
            <main className="app__page-content">
              <Routes>
                <Route path="/" element={<HomePage/>}/>
                <Route path="/my-work" element={<MyWorkPage/>}/>
                <Route path="/blog" element={<BlogPage/>}/>
                <Route path="/about-me" element={<AboutMePage/>}/>
                <Route path="/art-gallery" element={<ArtGallery/>}/>
              </Routes>
            </main>
          </BrowserRouter>
        </div>
      </>
    );
}

export default App;